import React, { Component } from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/shared/Buttons/ActionButton';

import {
  REQUEST_STATE_ERROR,
  REQUEST_STATE_RECEIVED
} from 'state/requests/RequestStatusReducer';
import { clearCancelPendingTransaction } from 'state/transaction/TransactionActions';
import { getPendingTransactions } from 'state/transaction/TransactionSelectors';
import { getCMMEmailAddress } from 'state/contactMethodMaintenance/ContactMethodMaintenanceSelectors';

import { getView } from 'state/view/ViewSelectors';
import { getCustomer } from 'state/customer/CustomerSelectors';

import CancelConfirmationModal from './CancelConfirmationModal';
import CancelFailureModal from './CancelFailureModal';

import './CancelTransaction.scss';
import LegacyToolTip, {
  PopUpPosition
} from 'components/shared/ToolTip/LegacyToolTip';
import Content from 'services/Content';
import {
  isActiveAdvisory,
  isActivePlus,
  isAlaska529,
  isMaryland529,
  isNational529,
  isPershingProduct,
  isWorkplaceRetirement
} from 'services/Products';
import { isDistributionToSchoolTransactionType } from 'services/Accounts';

const standardModalProps = {
  disableClickOff: true,
  hideAnchor: true,
  hideClose: true,
  isOpen: true
};

class CancelTransaction extends Component {
  state = { isOpen: false };
  componentDidUpdate(prevProps) {
    const { clearRequestStatus, requestStatus } = this.props;
    if (
      requestStatus !== prevProps.requestStatus &&
      requestStatus === REQUEST_STATE_RECEIVED
    ) {
      this.setState({ isOpen: false }, clearRequestStatus);
    }
  }
  render() {
    const {
      cellValueClass,
      clearRequestStatus,
      confirmationNumber,
      renderAsLink,
      requestStatus,
      userCancellable,
      fromProductType,
      toProductType,
      allPendingTransactions,
      customer,
      customerEmail,
      view,
      transactionType
    } = this.props;

    const getDTSTransactionCallToEditMessage = () => {
      if (isAlaska529(fromProductType)) {
        return Content.akPendingTransactionCallToEdit;
      }
      if (isMaryland529(fromProductType)) {
        return Content.mdPendingTransactionCallToEdit;
      }
      if (isNational529(fromProductType)) {
        return Content.natPendingTransactionCallToEdit;
      }
    };

    const callToEditText = () => {
      if (isActivePlus(fromProductType) || isActivePlus(toProductType)) {
        return Content.appPendingTransactionCallToEdit;
      }
      if (isDistributionToSchoolTransactionType(transactionType)) {
        return getDTSTransactionCallToEditMessage();
      }
      return Content.rasPendingTransactionCallToEdit;
    };

    if (
      isActivePlus(fromProductType) ||
      isActivePlus(toProductType) ||
      isActiveAdvisory(fromProductType) ||
      isActiveAdvisory(toProductType) ||
      isDistributionToSchoolTransactionType(transactionType)
    ) {
      return (
        <td className="transactions-pending-cell">
          <div className="call-to-edit" data-testid="legacy-tool-tip">
            <LegacyToolTip
              callerText="Call to Edit"
              header="Call to Edit this Transaction"
              message={callToEditText()}
              popOutPlacement={PopUpPosition.BOTTOM}
              maxNoteWidth="355px"
            />
          </div>
        </td>
      );
    }

    if (!userCancellable) {
      return null;
    }

    if (
      isWorkplaceRetirement(fromProductType) ||
      isPershingProduct(fromProductType)
    ) {
      return null;
    }

    return (
      <td
        className={`${cellValueClass} transactions-pending-cell transactions-pending-cancel-button`}>
        {renderAsLink ? (
          <a
            className="link-trigger"
            id="cancel-transaction-button"
            onClick={() => this.setState({ isOpen: true })}>
            Cancel
          </a>
        ) : (
          <ActionButton
            id="cancel-transaction-button"
            onClick={() => this.setState({ isOpen: true })}
            type="secondary">
            Cancel
          </ActionButton>
        )}
        {!this.state.isOpen ? null : requestStatus === REQUEST_STATE_ERROR ? (
          <CancelFailureModal
            closeModal={() =>
              this.setState({ isOpen: false }, clearRequestStatus)
            }
            standardModalProps={standardModalProps}
          />
        ) : (
          <CancelConfirmationModal
            confirmationNumber={confirmationNumber}
            closeModal={() => this.setState({ isOpen: false })}
            requestStatus={requestStatus}
            standardModalProps={standardModalProps}
            view={view}
            allPendingTransactions={allPendingTransactions}
            customer={customer}
            customerEmail={customerEmail ? customerEmail.address : ''}
          />
        )}
      </td>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  clearRequestStatus: () => dispatch(clearCancelPendingTransaction())
});
const mapStateToProps = (state) => ({
  requestStatus: state.requestStatus.cancelPendingTransaction || '',
  view: getView(state),
  allPendingTransactions: getPendingTransactions(state),
  customerEmail: getCMMEmailAddress(state),
  customer: getCustomer(state)
});
export default connect(mapStateToProps, mapDispatchToProps)(CancelTransaction);
